import numberWithCommas from './numberWithCommasFilter';

export default function(p, showZero, dollarSign = '$') {
    if (p) {
        return p || showZero
            ? dollarSign +
                  numberWithCommas(
                      p
                          .toFixed(2)
                          // show $9.9 instead of $9.90
                          .replace(/([0-9]+(\.[0-9]))(0+$)/, '$1')
                  )
            : '';
    } else if (p === undefined || p == null) {
        return '待定';
    } else if (p === 0) {
        return '免費';
    }
}
